import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

// Signed-in buyer marketplace: personalised inventory, never indexed.
export const Route = createFileRoute("/_app/buyer/")({
  head: () =>
    buildHead({
      title: "Buyer Marketplace | LohaLink",
      description: "Browse verified scrap metal lots with escrow-protected payment.",
      canonical: "/buyer",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/BuyerDashboard")),
});
